import { FC, ReactNode } from 'react'
import Popover from '@/components/UiElements/PopOver'
import Alert from '@/components/UiElements/Alert'

type ViewProfileItemProps = {
  profile: any
  className?: string
  onDelete?: (id: string) => void
  callBack: (item: any) => void
}

const Label = ({
  title,
  value,
  enable = true,
  className,
}: {
  title: string | ReactNode
  value: string | ReactNode
  enable?: boolean
  className?: string | null
}) => {
  return (
    <div
      className={`py-sm px-md h-[50px] rounded-md transition-all ${enable ? 'bg-gray-100 group-hover:bg-gray-200 ' : 'bg-gray-50 group-hover:bg-gray-100'} ${enable ? 'text-gray-900 group-hover:text-gray-900' : 'text-gray-400 group-hover:text-gray-900'} ${className || ''}`}
    >
      <p className={'text-gray-400 text-xs'}>{title}</p>
      <p className={` text-sm  capitalize `}>{value}</p>
    </div>
  )
}

const ViewProfileItems: FC<ViewProfileItemProps> = ({ profile, className = '', onDelete, callBack }) => {
  const handleDeleteItem = () => {
    Alert.showAlert({
      title: 'Delete view profile',
      isCancelable: true,
      danger: true,
      button: 'Delete!',
      message: (
        <div className={'flex flex-col items-center justify-center '}>
          Are you sure you want to delete the view profile &quot;{profile?.name}&quot;?
        </div>
      ),
      callBack: async (ok) => {
        if (ok && profile) {
          onDelete?.(profile.id)
        }
      },
    })
  }

  return (
    <div
      onClick={() => {
        callBack(profile)
      }}
      id={profile.id}
      className={`relative group active:bg-gray-100 flex py-sm  border-b-gray-200 border-b-[1px] items-center hover:bg-gray-50 cursor-pointer transition-all group gap-md px-md h-[140px] ${className} `}
    >
      <Popover
        toggle={(open) => (
          <div
            className={` select-none w-[37px] h-[37px] min-w-[37px] ${open ? 'text-white bg-gray-900' : ' bg-gray-200 hover:bg-gray-700 text-gray-900 hover:text-white'}     rounded-full flex-col justify-center items-center inline-flex font-icon-regular cursor-pointer transition-all`}
          >
            <div className="text-center ">ellipsis</div>
          </div>
        )}
        placement="bottom left"
        offsetX={0}
        offsetY={10}
        menu={[
          {
            title: <span className="capitalize">Edit Profile</span>,
            icon: '',
            onClick: () => callBack(profile),
          },
          {
            title: <span className="capitalize">Duplicate</span>,
            icon: '',
            onClick: () => callBack({ ...profile, id: 'duplicate' }),
          },
          { separator: true, className: 'my-[10px]' },
          {
            title: <span className="capitalize">Delete</span>,
            icon: '',
            className: 'hover:bg-red-100 text-red-500',
            onClick: handleDeleteItem,
          },
        ]}
      />

      <div className="flex flex-row gap-md items-center w-full">
        {profile.data?.view_url && (
          <div className="w-[100px] h-[100px] min-w-[100px] rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
            {profile.data?.model_thumbnail_image ? (
              <img
                src={profile.data.model_thumbnail_image}
                alt={profile.name}
                className="w-[90px] h-[90px] object-contain"
              />
            ) : (
              <div className="w-[90px] h-[90px] flex flex-col items-center justify-center text-gray-300">
                <span className="font-icon-regular text-[32px]">image</span>
                <span className="text-xs mt-xs">No preview</span>
              </div>
            )}
          </div>
        )}
        <div className="flex flex-col justify-between gap-md items-start transition-all h-[100px] w-full">
          <div className="text-title-md pl-md transition-all capitalize flex flex-col gap-0">
            {profile.name}
          </div>
          <div className="flex flex-row gap-sm justify-between w-full">
            <div className="flex flex-row gap-sm">
              <Label title="Name" value={profile.name || 'N/A'} className="w-[200px] capitalize" />
              <Label title="Type" value="3D" className="w-[80px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewProfileItems
